import type { Location, Ref } from "@sitescene/types";

/**
 * Resolve a Ref<T> to its id string, or undefined if missing.
 */
export const getRefId = <T extends { id: string }>(
	ref: null | Ref<T> | undefined,
): string | undefined => {
	if (!ref) return undefined;
	return typeof ref === "string" ? ref : ref.id;
};

/**
 * Collect unique installation IDs referenced by a location's zones and sensors.
 */
export const getLocationInstallationIds = (location: Location): string[] => {
	const ids = new Set<string>();

	for (const zone of location.zones ?? []) {
		const installationId = getRefId(zone.installation);
		if (installationId) ids.add(installationId);
	}

	for (const sensor of location.sensors ?? []) {
		const installationId = getRefId(sensor.installation);
		if (installationId) ids.add(installationId);
	}

	return [...ids];
};
